import GamesTimerIcon from "../../icons/games/GamesTimerIcon";
import formatTimer from "../../../helpers/TimeHelper";

export default function GamesTimeLeft({gameTimeLeft}) {
    // Used in GamesIndicators to display game time left

    // BUILD
    return (
        <div className={"bg-timerViolet w-[120px] min-w-[120px] h-[56px] min-h-[56px] " +
            "border-[1px] border-violetGrey rounded-[8px] " +
            "flex space-x-[8px] justify-center items-center"}>
            <GamesTimerIcon />
            <span className={"flex justify-start w-[48px] min-w-[48px] max-w-[48px] font-medium text-white text-[22px]"}>
                {formatTimer(gameTimeLeft)}
            </span>
        </div>
    );
}